import {BaseApi, HttpMethodEnum} from '../BaseApi/BaseApi';
import {ILabTest} from '../../entities/LabTest/LabTest.ts';
import {ILabResult} from '../../entities/LabTest/LabResult';
import {IFileInfo} from '../../entities/FileInfo/FileInfo';
import {IUnit} from '../../entities/PhysiologicalData/PhysiologicalData';

export class LabTestApi extends BaseApi {
    public static apiUrls = {
        getLabTests: `${BaseApi.apiUrl}/Patients/:id/LabTests`,
        getPendingLabTests: `${BaseApi.apiUrl}/Patients/:id/PendingLabTests`,
        updateLabTest: `${BaseApi.apiUrl}/LabTests/:id/Manual`,
        getUploadUrl: `${BaseApi.apiUrl}/LabTests/:id/UploadURL/:filename/Manual`,
        getFiles: `${BaseApi.apiUrl}/LabTests/:id/Files`,
        getDownloadUrl: `${BaseApi.apiUrl}/LabTests/:id/DownloadURL/:filename`,
    };

    public static async getLabTests(id: string): Promise<ILabTest[]> {
        return this.sendApiRequest<ILabTest[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getLabTests,
            data: undefined,
            id: id
        });
    }

    public static async getPendingLabTests(id: string): Promise<ILabTest[]> {
        return this.sendApiRequest<ILabTest[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getPendingLabTests,
            data: undefined,
            id: id
        });
    }

    public static async updateLabTest(id: string, labResult: ILabResult): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.updateLabTest,
            data: labResult as any,
            id: id
        });
    }

    public static async getUploadUrl(id: string, filename: string): Promise<string> {
        const path = this.apiUrls.getUploadUrl.replace(':filename', filename);
        return this.sendApiRequest<string>({
            method: HttpMethodEnum.GET,
            path: path,
            data: undefined,
            id: id
        });
    }

    public static async getFiles(id: string): Promise<IFileInfo[]> {
        return this.sendApiRequest<IFileInfo[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getFiles,
            data: undefined,
            id: id
        });
    }

    public static async getDownloadUrl(id: string, filename: string): Promise<string> {
        const path = this.apiUrls.getDownloadUrl.replace(':filename', filename);
        return this.sendApiRequest<string>({
            method: HttpMethodEnum.GET,
            path: path,
            data: undefined,
            id: id
        });
    }

    public static async uploadFile(uploadUrl: string, file: File): Promise<void> {
        const response = await fetch(uploadUrl, {
            method: 'PUT',
            body: file,
        });

        if (!response.ok) 
            throw new Error('Upload failed');
        
    }

    public static async getLabTestUnits(): Promise<IUnit[]> {
        return this.sendApiRequest<IUnit[]>({
            method: HttpMethodEnum.GET,
            path: `${BaseApi.apiUrl}/LabTests/Units`
        });
    }

    public static async deleteFile(labTestId: string, filename: string): Promise<boolean> {
        return this.sendApiRequest<boolean>({
            method: HttpMethodEnum.DELETE,
            path: `${BaseApi.apiUrl}/LabTests/${labTestId}/Files/${encodeURIComponent(filename)}`
        });
    }
}
